import { api } from './http'
import { or, and, searchParam } from './filters'

// Fábrica genérica de API CRUD para entidades Qualita.
//   resource: nombre del recurso REST (ej. 'productos', 'formapago').
//   listView: vista para listar (default 'BaseList').
//   searchPaths: paths para el typeahead/buscador (se arma un OR de `like`).
//
// Las listas de Qualita usan ?view=<View>&search=<JSON>. El alta/edición es POST/PUT
// del objeto (con anidados trimeados a {id}; cada ABM define su toPayload).
export function makeCrud(resource, { listView = 'BaseList', searchPaths = ['descripcion'] } = {}) {
  const base = `/${resource}`

  function buscar(texto = '', extraFilters = []) {
    const filtros = []
    if (texto && texto.length >= 1 && searchPaths.length) {
      filtros.push(or(searchPaths.map((p) => and([{ path: p, like: texto }]))))
    }
    extraFilters.forEach((f) => filtros.push(f))
    const params = filtros.length
      ? searchParam(filtros.length === 1 ? filtros[0] : and(filtros), { view: listView })
      : { view: listView }
    return api.get(base, { params }).then((r) => {
      const d = r.data
      return Array.isArray(d) ? d : d?.list || d?.data || []
    })
  }

  function listar(params = {}) {
    return api.get(base, { params: { view: listView, ...params } }).then((r) => {
      const d = r.data
      return Array.isArray(d) ? d : d?.list || d?.data || []
    })
  }

  function get(id, view = listView) {
    return api.get(`${base}/${id}`, { params: { view } }).then((r) => r.data)
  }

  function crear(payload) {
    return api.post(base, payload).then((r) => r.data)
  }

  function actualizar(id, payload) {
    return api.put(`${base}/${id}`, payload).then((r) => r.data)
  }

  function eliminar(id) {
    return api.delete(`${base}/${id}`).then((r) => r.data)
  }

  return { base, buscar, listar, get, crear, actualizar, eliminar }
}

export const idOf = (o) => (o && o.id != null ? { id: o.id } : null)
